import { isEmpty, isNil } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
import RffDateField from "../../../../../components/finalForm/inputs/RffDateField";
import RffDollarField from "../../../../../components/finalForm/inputs/RffDollarField";
import RffTextareaField from "../../../../../components/finalForm/inputs/RffTextareaField";
import RffTextField from "../../../../../components/finalForm/inputs/RffTextField";
import RffGroup from "../../../../../components/finalForm/shared/RffGroup";
import InsetCard from "../../../../../components/ui/InsetCard";
import { selectOptionsWireStatus } from "../../../../../constants/selectOptions/selectOptionsWireStatus";
import RffFormChanges from "../../../../../components/finalForm/RffFormChanges";
import UnsavedChangesAlert from "../../../../../components/common/UnsavedChangesAlert";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLoanTermsHook } from "../../../../../hooks/useLoanTermsHook";
import { loanFetchedDataLoanTermsSet } from "../../../../../redux/reducers/loanFetchedDataReducer";
import RffSelectToggleField from "../../../../../components/finalForm/inputs/RffSelectToggleField";

// const ITEM_NAME = "Originator Credit";
const LoanFeesSubTabWireInstructions = () => {
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);

  // const rowData = useMemo(
  //   () => loanTerms?.originatorCredits || [],
  //   [loanTerms?.originatorCredits]
  // );
  // const headerSubtitle = useMemo(() => {
  //   if (isEmpty(rowData)) {
  //     return `Add and manage ${ITEM_NAME.toLowerCase()}s associated with this loan.`;
  //   }
  //   return `Click any of the following rows to edit a ${ITEM_NAME.toLowerCase()}`;
  // }, [rowData]);

  // const onRowClicked = useCallback((d) => {
  //   dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_CREDIT));
  //   dispatch(sidebarSetParamsValue(null));
  //   dispatch(sidebarSetStateValue(d));
  // }, []);

  return (
    <PrimaryContentCard
      maxWidth="md"
      title={"Wire Instructions"}
      // title={ITEM_NAME + "s"}
      // subTitle={headerSubtitle}
      // endContent={<LoanDrilldownButtonAddCredit />}
      loading={isNil(loanTerms)}
      // cardSx={{ pb: 0 }}
    >
      {/* <Box sx={{ p: 0, overflow: "hidden", mx: -4 }}>
        <OriginatorFeesTable onRowClicked={onRowClicked} rowData={rowData} />
      </Box> */}
      {/* <WireInstructionsContent /> */}
      <InsetCard sx={{ overflow: "hidden" }}>
        <WireInstructionsContent />
      </InsetCard>
    </PrimaryContentCard>
  );
};

const WireInstructionsContent = ({ children }) => {
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const { loading, updateLoanTermsObject, createLoanTermsObject } =
    useLoanTermsHook();
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState(null);
  const [formKey, setFormKey] = useState(0); // Key to force form re-initialization

  const wireInstructionsData = loanTerms?.wireInstructions || {};

  // const handleOnUpdate = useCallback((changedData) => {
  //   console.log("Changed Data:", changedData);
  //   return;
  //   updateLoanTermsObjectData({
  //     loanId: loanDrilldown?._id,
  //     objectType: "wireInstructions",
  //     data: changedData,
  //     onSuccessFn: (response) => {
  //       dispatch(loanFetchedDataLoanTermsSet(response));
  //       if (!isEmpty(loanTerms)) {
  //         dispatch(loanFetchedDataLoanTermsSet(null));
  //       }
  //     },
  //   });
  // }, []);

  const isUpdating = useMemo(
    () => !isEmpty(loanTerms?.wireInstructions),
    [loanTerms?.wireInstructions]
  );

  const handleOnUpdate = useCallback(
    (changedData) => {
      const requestParams = {
        dealId: loanDrilldown?._id,
        objectType: "wireInstructions",
        data: changedData,
        onSuccessFn: (response) => {
          dispatch(loanFetchedDataLoanTermsSet(response));
          // if (!isEmpty(loanTerms)) {
          //   dispatch(loanFetchedDataLoanTermsSet(null));
          // }
        },
      };

      if (isUpdating) {
        // console.log("updating", requestParams);
        // return;
        updateLoanTermsObject(requestParams);
      } else {
        // console.log("creating", requestParams);
        // return;
        createLoanTermsObject(requestParams);
      }
    },
    [loanDrilldown?._id, isUpdating]
  );
  useEffect(() => {
    if (isNil(initialValues)) {
      setTimeout(() => {
        setInitialValues(wireInstructionsData);
        // setInitialValues(loanDrilldown);
        setFormKey((prev) => prev + 1); // Force form re-initialization
      }, 100);
    } else {
      // console.log("ELSE", loanDrilldown);
      setInitialValues(loanTerms?.wireInstructions);
      setFormKey((prev) => prev + 1);
    }
  }, [loanTerms?.wireInstructions]);
  return (
    <RffFormChanges
      key={formKey}
      // formSpy
      initialValues={initialValues}
      suppressFooter
      onSubmit={handleOnUpdate}
      hasChangesContent={
        <UnsavedChangesAlert
          loading={loading}
          onCancel={() => {
            setInitialValues(initialValues);
            setFormKey((prev) => prev + 1);
          }}
        />
      }
    >
      <RffGroup suppressBottomMargin>
        <RffDateField
          size={6}
          label="Wire Request Date"
          name="wireRequestDate"
        />
        <RffDollarField size={6} label="Wire Amount" name="wireAmount" />
        <RffSelectToggleField
          label="Wire Status"
          name="wireStatus"
          options={selectOptionsWireStatus}
        />
        <RffTextField
          size={6}
          label="Wire Fed Ref Number"
          name="wireFedRefNumber"
        />
        <RffDateField
          size={6}
          label="Closing Wire Release Date"
          name="closingWireReleaseDate"
        />
        <RffTextareaField
          minHeight={80}
          // size={4}
          label="Wire Remarks/Notes"
          name="wireNotes"
        />
      </RffGroup>
    </RffFormChanges>
  );
};

export default LoanFeesSubTabWireInstructions;
// import { isEmpty, isNil } from "lodash";
// import { useDispatch, useSelector } from "react-redux";
// import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
// import RffDateField from "../../../../../components/finalForm/inputs/RffDateField";
// import RffDollarField from "../../../../../components/finalForm/inputs/RffDollarField";
// import RffSelectField from "../../../../../components/finalForm/inputs/RffSelectField";
// import RffTextareaField from "../../../../../components/finalForm/inputs/RffTextareaField";
// import RffTextField from "../../../../../components/finalForm/inputs/RffTextField";
// import RffForm from "../../../../../components/finalForm/RffForm";
// import RffGroup from "../../../../../components/finalForm/shared/RffGroup";
// import InsetCard from "../../../../../components/ui/InsetCard";
// import { selectOptionsWireStatus } from "../../../../../constants/selectOptions/selectOptionsWireStatus";
// import LoanDrilldownButtonAddCredit from "../../../buttons/LoanDrilldownButtonAddCredit";
// import RffFormChanges from "../../../../../components/finalForm/RffFormChanges";
// import UnsavedChangesAlert from "../../../../../components/common/UnsavedChangesAlert";
// import { useCallback, useEffect, useMemo, useState } from "react";
// import { useLoanTermsHook } from "../../../../../hooks/useLoanTermsHook";
// import { loanFetchedDataLoanTermsSet } from "../../../../../redux/reducers/loanFetchedDataReducer";
// import RffSelectToggleField from "../../../../../components/finalForm/inputs/RffSelectToggleField";
// import { object } from "prop-types";

// // const ITEM_NAME = "Originator Credit";
// const LoanFeesSubTabWireInstructions = () => {
//   const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
//   const dispatch = useDispatch();

//   // const rowData = useMemo(
//   //   () => loanTerms?.originatorCredits || [],
//   //   [loanTerms?.originatorCredits]
//   // );
//   // const headerSubtitle = useMemo(() => {
//   //   if (isEmpty(rowData)) {
//   //     return `Add and manage ${ITEM_NAME.toLowerCase()}s associated with this loan.`;
//   //   }
//   //   return `Click any of the following rows to edit a ${ITEM_NAME.toLowerCase()}`;
//   // }, [rowData]);

//   // const onRowClicked = useCallback((d) => {
//   //   dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_CREDIT));
//   //   dispatch(sidebarSetParamsValue(null));
//   //   dispatch(sidebarSetStateValue(d));
//   // }, []);

//   return (
//     <PrimaryContentCard
//       maxWidth="md"
//       title={"Wire Instructions"}
//       // title={ITEM_NAME + "s"}
//       // subTitle={headerSubtitle}
//       // endContent={<LoanDrilldownButtonAddCredit />}
//       loading={isNil(loanTerms)}
//       // cardSx={{ pb: 0 }}
//       bodySx={{ pt: 3 }}
//     >
//       <WireInstructionsContent />
//       {/* <InsetCard sx={{ overflow: "hidden" }}>
//         <WireInstructionsContent />
//       </InsetCard> */}
//     </PrimaryContentCard>
//   );
// };

// const WireInstructionsContent = ({ children }) => {
//   const loanDrilldown = useSelector((state) => state.loanDrilldown);
//   const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
//   const { loading, createLoanTermsObject, updateLoanTermsObject } =
//     useLoanTermsHook();
//   const dispatch = useDispatch();

//   const wireInstructionsInit = {
//     wireAmount: 32343,
//     closingWireReleaseDate: "2025-12-17T00:00:00.000Z",
//     wireNotes: "weqwe",
//     wireStatus: "Tee-up Done",
//   };
//   // const wireInstructionsInit = loanTerms?.wireInstructions || {};
//   const initData = useMemo(
//     () => loanTerms?.wireInstructions,
//     [loanTerms?.wireInstructions]
//   );

//   const initialValues = useMemo(() => {
//     return wireInstructionsInit;
//   }, [wireInstructionsInit]);

//   // const wireInstructionsInit = loanTerms?.wireInstructions || {};
//   const isUpdating = useMemo(
//     () => !isEmpty(initData),
//     [initData]
//     // const isUpdating = useMemo(
//     //   () => !isEmpty(loanTerms?.wireInstructions),
//     //   [loanTerms?.wireInstructions]
//   );
//   const [localInitialValues, setLocalInitialValues] = useState(null);
//   const [formKey, setFormKey] = useState(0); // Key to force form re-initialization

//   const handleOnUpdate = useCallback((changedData) => {
//     const requestParams = {
//       loanId: loanDrilldown?._id,
//       objectType: "wireInstructions",
//       data: changedData,
//       onSuccessFn: (response) => {
//         dispatch(loanFetchedDataLoanTermsSet(response));
//         // if (!isEmpty(loanTerms)) {
//         //   dispatch(loanFetchedDataLoanTermsSet(null));
//         // }
//       },
//     };

//     if (isUpdating) {
//       console.log("updating", requestParams);
//       // return;
//       // updateLoanTermsObject(requestParams);
//     } else {
//       console.log("creating", requestParams);
//       // return;
//       // createLoanTermsObject(requestParams);
//     }
//   }, []);

//   useEffect(() => {
//     if (isNil(localInitialValues)) {
//       setTimeout(() => {
//         setLocalInitialValues(initData);
//         setFormKey((prev) => prev + 1); // Force form re-initialization
//       }, 100);
//     } else {
//       // console.log("ELSE", loanDrilldown);
//       // setInitialValues(profile);
//       setFormKey((prev) => prev + 1);
//     }
//   }, [initData]);
//   return (
//     <RffFormChanges
//       formSpy
//       key={formKey}
//       initialValues={initData}
//       suppressFooter
//       onSubmit={handleOnUpdate}
//       hasChangesContent={
//         <UnsavedChangesAlert
//           loading={loading}
//           onCancel={() => {
//             setLocalInitialValues(initialValues);
//             setFormKey((prev) => prev + 1);
//           }}
//         />
//       }
//     >
//       <RffGroup suppressBottomMargin>
//         <RffDateField
//           size={6}
//           label="Wire Request Date"
//           name="wireRequestDate"
//         />
//         <RffDollarField size={6} label="Wire Amount" name="wireAmount" />
//         <RffSelectToggleField
//           label="Wire Status"
//           name="wireStatus"
//           options={selectOptionsWireStatus}
//         />
//         <RffTextField
//           size={6}
//           label="Wire Fed Ref Number"
//           name="wireFedRefNumber"
//         />
//         <RffDateField
//           size={6}
//           label="Closing Wire Release Date"
//           name="closingWireReleaseDate"
//         />
//         <RffTextareaField
//           minHeight={80}
//           // size={4}
//           label="Wire Remarks/Notes"
//           name="wireNotes"
//         />
//       </RffGroup>
//     </RffFormChanges>
//   );
// };

// export default LoanFeesSubTabWireInstructions;
